import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthCoordinatorService } from '@shared/services/auth-coordinator.service';
import { Observable, of } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';

export const authenticationGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> => {
  const authCoordinator = inject(AuthCoordinatorService);
  const router = inject(Router);

  // Wait for auth coordinator initialization to complete
  return authCoordinator.isInitializing$.pipe(
    filter(isInitializing => !isInitializing),
    take(1),
    switchMap(() => {
      // Check authentication status after initialization
      if (authCoordinator.isAuthenticated()) {
        return of(true);
      }

      // Redirect to login if not authenticated
      const loginUrl = authCoordinator.getLoginRedirectUrl();
      if (loginUrl.startsWith('http')) {
        // SSO redirect
        authCoordinator.redirectToLogin();
      } else {
        // Regular login redirect
        router.navigate([loginUrl], { queryParams: { redirect: state.url } });
      }
      return of(false);
    })
  );
};
